import React from 'react';
import './StatusCellRenderer.scss';



export const StatusCellRenderer = (params: any) => {

    const AVAILABLE_COLOR_STATUS:any={'reviewed':'#008813','awaiting review':'#FF644C','no review required':'#FF9847','unreviewed':'#FF644C',}

    return (
        < >
            {params.data.insight_display_status?.split('-').map((item: string) => {
                return (<div className='status_column' style={{ color:AVAILABLE_COLOR_STATUS[item]?AVAILABLE_COLOR_STATUS[item]:'#606060' }}>  {item.replaceAll('_',' ')} </div>)
            }
            )}
        </ >
    );
}